<template>
  <div id="social-share"
       class="social-share"
       :class="{'disInlBI m0I vertical-align-middle': inline}">
    <div class="social-share-displayed">
      <p v-if="showText"> {{ $t('socialShare.compartir') }}</p>
      <span class="social-share-button"
            :class="{'m0I': inline}"
            @click="showModal = true" />
    </div>
    <social-share-modal v-if="showModal"
                        :url="url"
                        @closeShareModal="showModal = false" />
  </div>
</template>

<script>
import SocialShareModal from '@/components/social-share/SocialShareModal.vue'

export default {
  components: {
    SocialShareModal
  },
  props: {
    showText: {
      type: Boolean,
      default: false
    },
    url: {
      type: String,
      default: undefined
    },
    type: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    showModal: false
  })
}
</script>

<style lang="scss">
@import './social-share.sass';
</style>
